import { GridToolbarColumnsButton, GridToolbarContainer } from '@mui/x-data-grid-pro';
import { ThemeProvider } from '@mui/material/styles';
import {
  customButtonTheme,
  customToolbarButtonTheme,
} from 'assets/styles/themes/generic_button_mui';
import { Button as MButton } from '@mui/material';

type CustomToolbarProcedureParams = {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  typeProcedure: string;
};

export const CustomToolbarProcedure = ({
  setModal,
  typeProcedure,
}: CustomToolbarProcedureParams) => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton
        slotProps={{
          button: { sx: { color: '#277134' } },
        }}
      />
      <div className="d-flex justify-space-between">
        {/* <ThemeProvider theme={customToolbarButtonTheme}>
          <MButton> Importer les données</MButton>
        </ThemeProvider> */}
        {typeProcedure !== 'backward' && (
          <ThemeProvider theme={customToolbarButtonTheme}>
            <MButton onClick={() => setModal(true)}> Ajouter une parcelle</MButton>
          </ThemeProvider>
        )}
      </div>
    </GridToolbarContainer>
  );
};
